import { Translation } from 'react-i18next';

import { useModals } from '@any-ui-react/modals';

export const useBackToDraftModal = () => {
  const { openConfirmModal } = useModals();

  const openBackToDraftModal = async (onConfirm: () => void) => {
    openConfirmModal({
      title: (
        <Translation ns="anychat">
          {(t) => <>{t('anychat.broadcast.form.dialogs.backToDraft.title')}</>}
        </Translation>
      ),
      children: (
        <Translation ns="anychat">
          {(t) => <>{t('anychat.broadcast.form.dialogs.backToDraft.desc')}</>}
        </Translation>
      ),
      labels: {
        confirm: (
          <Translation ns="anychat">
            {(t) => <>{t('anychat.broadcast.form.dialogs.backToDraft.confirm')}</>}
          </Translation>
        ),
      },
      onConfirm,
    });
  };

  return { openBackToDraftModal };
};
